import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import * as yup from 'yup';

// @mui material components
import Card from '@mui/material/Card';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDTypography from 'components/MDTypography';

import { loginUser } from 'store/reducers/authSlice';

function Login() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const loginSchema = yup.object({
    email: yup
      .string()
      .email(`Please enter a valid email address`)
      .required(`Email is required`),
    password: yup.string().required(`Password is required`),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(loginSchema),
  });

  const onLoginSubmit = async (data) => {
    try {
      await dispatch(loginUser(data));
      navigate(`/verify-otp`, { replace: true });
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <Card sx={{ minWidth: '330px' }}>
      <MDBox
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
        mx={2}
        mt={-3}
        p={2}
        mb={1}
        textAlign="center"
      >
        <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
          Sign in
        </MDTypography>
      </MDBox>
      <MDBox pt={4} pb={3} px={3}>
        <MDBox component="form" role="form">
          <MDBox mb={2}>
            <MDInput
              {...register('email')}
              type="email"
              label="Email"
              error={!!errors?.email}
              helperText={
                errors?.email && (
                  <MDTypography color="error" variant="caption">
                    {errors?.email?.message}
                  </MDTypography>
                )
              }
              fullWidth
            />
          </MDBox>
          <MDBox mb={2}>
            <MDInput
              {...register('password')}
              type="password"
              label="Password"
              error={!!errors?.password}
              helperText={
                errors?.password && (
                  <MDTypography color="error" variant="caption">
                    {errors?.password?.message}
                  </MDTypography>
                )
              }
              fullWidth
            />
          </MDBox>
          {/* NOTE: commented for future use */}
          <MDBox display="flex" alignItems="center" ml={-1}>
            {/* <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: 'pointer', userSelect: 'none', ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography> */}
          </MDBox>
          <MDBox mt={4} mb={1}>
            <MDButton
              type="submit"
              onClick={handleSubmit(onLoginSubmit)}
              variant="gradient"
              color="info"
              fullWidth
              disableRipple
              disabled={
                Object.keys(errors).length > 0 || !isValid || isSubmitting
              }
            >
              sign in
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Login;
